import { LONG_getInstance2g4gwhhf21sqr as LONG_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration5ynfiptaqcrg as Duration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { rangeTo3js8ciqegc9cl as rangeTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DurationMsSerializerClass;
function DurationMsSerializer() {
  if (DurationMsSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationMsSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlin.time.Duration/milliseconds', LONG_getInstance());
      }
      deserialize_gg0puu_k$(decoder) {
        var tmp;
        try {
          Companion_getInstance();
          // Inline function 'kotlin.time.Companion.milliseconds' call
          var this_0 = decoder.decodeLong_jzt186_k$();
          tmp = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Exception()) {
            var e = $p;
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Duration())(this.deserialize_gg0puu_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_fhst7c_k$(encoder, value) {
        return encoder.encodeLong_vlw3uq_k$(_Duration___get_inWholeMilliseconds__impl__msfiry(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fhst7c_k$(encoder, value instanceof Duration() ? value.rawValue_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DurationMsSerializer', VOID, VOID, [KSerializer()]);
    DurationMsSerializerClass = $;
  }
  return DurationMsSerializerClass;
}
var DurationMsSerializer_instance;
function DurationMsSerializer_getInstance() {
  if (DurationMsSerializer_instance === VOID)
    new (DurationMsSerializer())();
  return DurationMsSerializer_instance;
}
var ClosedRangeSerializerClass;
function ClosedRangeSerializer() {
  if (ClosedRangeSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.inner_1 = inner;
        var tmp = this;
        tmp.descriptor_1 = buildClassSerialDescriptor('kotlin.ranges.ClosedRange', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('start', this.inner_1.get_descriptor_wjt6a0_k$());
          $this$buildClassSerialDescriptor.element$default_ey7ac9_k$('endInclusive', this.inner_1.get_descriptor_wjt6a0_k$());
          return Unit_instance;
        });
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        var start = {_v: null};
        var endInclusive = {_v: null};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        $l$loop: while (true) {
          var index = composite.decodeElementIndex_bstkhp_k$(this.descriptor_1);
          switch (index) {
            case -1:
              break $l$loop;
            case -3:
              break;
            case 0:
              start._v = composite.decodeSerializableElement$default_j0zaoi_k$(this.descriptor_1, index, this.inner_1);
              break;
            case 1:
              endInclusive._v = composite.decodeSerializableElement$default_j0zaoi_k$(this.descriptor_1, index, this.inner_1);
              break;
          }
        }
        var result = Unit_instance;
        composite.endStructure_1xqz0n_k$(descriptor);
        var tmp;
        if (start._v == null) {
          throwUninitializedPropertyAccessException('start');
        } else {
          tmp = start._v;
        }
        var tmp_0 = tmp;
        var tmp_1;
        if (endInclusive._v == null) {
          throwUninitializedPropertyAccessException('endInclusive');
        } else {
          tmp_1 = endInclusive._v;
        }
        return rangeTo(tmp_0, tmp_1);
      }
      serialize_i3zjr3_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeSerializableElement_isqxcl_k$(this.descriptor_1, 0, this.inner_1, value.get_start_iypx6h_k$());
        composite.encodeSerializableElement_isqxcl_k$(this.descriptor_1, 1, this.inner_1, value.get_endInclusive_r07xpi_k$());
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_i3zjr3_k$(encoder, (!(value == null) ? isInterface(value, ClosedRange()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ClosedRangeSerializer', VOID, VOID, [KSerializer()]);
    ClosedRangeSerializerClass = $;
  }
  return ClosedRangeSerializerClass;
}
//region block: exports
export {
  ClosedRangeSerializer as ClosedRangeSerializer1wdhu7jrbhw7o,
  DurationMsSerializer_getInstance as DurationMsSerializer_getInstancecr673uo7gg5q,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
